// src/scenes/roles/AddRole.jsx
import { useState } from "react";
import * as yup from "yup";
import axios from "axios";
import Header from "../../components/Header";
import SimpleForm from "../../components/SimpleForm";
import { Snackbar, Alert } from "@mui/material";


/* ---------- tiny helpers (same logic as your other page) ---------- */
const buildInitials = (fields) =>
  fields.reduce((acc, f) => {
    const def =
      f.default ??
      (f.type === "checkbox" ? false :
       f.type === "number" ? 0 :
       "");
    acc[f.name] = def;
    return acc;
  }, {});

const buildSchema = (fields) => {
  const shape = {};
  fields.forEach((f) => {
    let rule;
    switch (f.type) {
      case "email": rule = yup.string().email("invalid email"); break;
      case "number": rule = yup.number().typeError("must be a number"); break;
      case "checkbox": rule = yup.boolean(); break;
      default: rule = yup.string();
    }
    if (f.required) rule = rule.required("required");
    if (f.min != null) rule = rule.min(f.min);
    if (f.max != null) rule = rule.max(f.max);
    if (f.matches) rule = rule.matches(f.matches.regex, f.matches.message);
    shape[f.name] = rule;
  });
  return yup.object().shape(shape);
};

/* ---------- axios instance (CRA uses REACT_APP_*) ---------- */
const token = localStorage.getItem("token");

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

async function postJSON(path, payload) {
  try {
    const res = await api.post(path, payload);
    return { data: res.data, error: null };
  } catch (err) {
    const responseData = err?.response?.data;
    const message =
      responseData?.error?.errors?.[0]?.message || // Sequelize detailed message
      responseData?.message ||
      err.message ||
      "Request failed";
    return { data: responseData, error: message };
  }
}

/* ---------- form fields (match your POST body) ---------- */
const FIELDS = [
  {
    name: "name",
    label: "Role Name",
    type: "text",
    span: 3,
    required: true,
    props: { placeholder: "eg. StoreKeeper" },
  },
];

const INITIALS = buildInitials(FIELDS);
const SCHEMA = buildSchema(FIELDS);

/* ---------- page component ---------- */
export default function CreateRole() {
  const [toast, setToast] = useState({ open: false, msg: "", sev: "success" });

const handleSubmit = async (
  values,
  { setSubmitting, setErrors, resetForm }
) => {
  try {
    setSubmitting(true);

   

    
    const payload = {
      ...values,
      
    };

    const { data, error } = await postJSON("/api/role", payload);

    // 🔥 handle unique constraint error
    const isSequelizeUnique =
      data?.error?.name === "SequelizeUniqueConstraintError" ||
      data?.error?.errors?.[0]?.type === "unique violation" ||
      /duplicate entry/i.test(error || "");

    if (isSequelizeUnique) {
      const msg =
        data?.error?.errors?.[0]?.message || "name must be unique";

      setErrors({ name: msg });
      setToast({
        open: true,
        msg: `Error: ${msg}`,
        sev: "error",
      });
      return;
    }

    if (error) {
      setToast({
        open: true,
        msg: `Error: ${error}`,
        sev: "error",
      });
      return;
    }

    setToast({
      open: true,
      msg: data?.message || "Role created successfully",
      sev: "success",
    });

    resetForm();
  } catch (err) {
    setToast({
      open: true,
      msg: err.message || "Something went wrong",
      sev: "error",
    });
  } finally {
    setSubmitting(false);
  }
};


  return (
    <>
      <SimpleForm
        title="ADD ROLE"
        subtitle="Create a new role"
        Header={Header}
        fields={FIELDS}
        initialValues={INITIALS}
        validation={SCHEMA}
        onSubmit={handleSubmit}
        submitLabel="Create Role"
      />

      <Snackbar
       anchorOrigin={{ vertical: 'top', horizontal: 'right'}}
      sx={{ mt: 5 }}
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((s) => ({ ...s, open: false }))}
      >
        <Alert
          onClose={() => setToast((s) => ({ ...s, open: false }))}
          severity={toast.sev}
          variant="filled"
        >
          {toast.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
